export const pasrsGropsForReleases = data => {
  // shema
  const releasesData = {
    releases: [],
    ArticlesStatistics: {
      widget: {
        NumberOfOutputs: undefined,
        totalAudience: undefined,
        totalNumberOfViews: undefined
      }
    },
    articles: [],
    delete: undefined
  };

  // releases
  data.pressReleases.forEach(e => {
    if (!e.deleted) {
      releasesData.releases.push({
        idRelease: e.id,
        date: e.createdDate,
        heading: e.articleTitle
      });
    }
  });

  // widgets info
  let NumberOfOutputs = data.articlesLen;
  let totalAudience = data.totalAttendance;
  let totalNumberOfViews = data.totalAverageAttendance;

  releasesData.ArticlesStatistics = {
    widget: {
      NumberOfOutputs,
      totalAudience,
      totalNumberOfViews
    }
  };

  // articles
  releasesData.articles = data.articles;
  // releasesData.articles = false;

  return releasesData;
};

export const pasrsReleaseForStatistics = data => {
  // shema
  const releasesData = {
    release: {
      title: undefined,
      text: undefined,
      date: undefined
    },
    ArticlesStatistics: {
      widget: {
        NumberOfOutputs: undefined,
        totalAudience: undefined,
        totalNumberOfViews: undefined
      }
    },
    articles: [],
    articlesDeleted: []
  };

  // releases
  releasesData.release = {
    title: data.articleTitle,
    text: data.articleText,
    date: data.createdDate
  };

  // widgets info

  releasesData.ArticlesStatistics = {
    widget: {
      NumberOfOutputs: data.articles.length,
      totalAudience: data.totalAttendance,
      totalNumberOfViews: data.totalAverageAttendance
    }
  };

  // articles
  releasesData.articles = data.articles;

  releasesData.articlesDeleted = data.articlesDeleted;

  return releasesData;
};

export const pasrsGropsForChips = data => {
  const dataForChips = [];
  data.pressReleases.forEach(e => {
    if (!e.deleted) {
      dataForChips.push({ name: e.title, id: e.id });
    }
  });

  return dataForChips;
};

export const parsChartFromBack = data => {
  return data.map((chart, index) => {
    const forData = [];
    for (const key in chart.chartData) {
      if (index !== 0) {
        forData.push({ name: key, value: chart.chartData[key] });
      } else {
        forData.push({ name: key, uv: chart.chartData[key] });
      }
    }
    return { titleChart: chart.chartTitle, data: forData };
  });
};
